/**
 * Checks if a React Router path pattern matches a concrete path.
 * Handles parameterized routes (e.g., /projects/:projectId matches /projects/123).
 */
export function matchesRoutePattern(pattern: string, path: string): boolean {
  // Convert pattern to regex
  const regexPattern = pattern
    .replace(/:[^/]+/g, '[^/]+') // Replace :param with [^/]+
    .replace(/\//g, '\\/'); // Escape slashes

  const regex = new RegExp(`^${regexPattern}$`);
  return regex.test(path);
}
